import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic AQUAAEROBIK GOTOWY reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-275" data-mp="3fym86mxaf65e">
      <div className="mx-auto max-w-6xl" data-id="element-276" data-mp="3azt2vhs5mlgb">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-277" data-mp="3ayqbl8qx6gzv">
          Co mówią <em className="text-red-700" data-id="element-278" data-mp="3205z4pbyd3k3">instruktorzy</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-279" data-mp="321zauj1fadyy">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-280" data-mp="2s1qaqu4b88ea">
              <div className="text-sm text-amber-500" aria-label="5 na 5 gwiazdek" data-id="element-281" data-mp="2s3jk4h6b56pz">
                <span aria-hidden="true" data-id="element-282" data-mp="v8wu4c4erodr">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-283" data-mp="qa3qdbexbbqs">
                „{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-284" data-mp="h8awv9l20jp4">
                <span className="font-semibold text-slate-900" data-id="element-285" data-mp="m62sadkwqny2">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-286" data-mp="78k2r90eo6pk"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}